function MyWebSocket(options) {
  const { heartState = true, maxLinks = 0 } = options;
  const protocols = [];

  const _self = this; // 本对象
  let _ws = null; // websocket对象
  let _forcedClose = false; // 强制关闭
  let _timedOutStatus = false; // 超时状态
  let _eventOnPools = {}; // 事件订阅池
  let _reTimeout = null; // 定时重连的ID
  let _url = null;

  // These can be altered by calling code.
  this.debug = false; // 日志模式
  this.reconnectInterval = 1000; // 重连间隔
  this.reconnectDecay = 0; // 重连衰减
  this.reconnectAttemptCount = 0; // 重连尝试次数
  this.maxLinks = maxLinks; // 最大重连次数，等于 0 时一直连
  this.timeoutInterval = 2000; //
  this.protocols = protocols;
  this.readyState = WebSocket.CONNECTING; // 准备状态
  this.heartState = heartState; // 是否使用心跳机制

  // 初始化订阅池的事件类型
  _eventOnPools = {
    onopen: {},
    onclose: {},
    onconnecting: {},
    onmessage: {},
    onerror: {}
  };

  this.init = function(url) {
    _url = url;
    this.connect();
  };
  // 心跳机制
  const heart = {
    timeOut: 60000,
    timeObj: null,
    serverTimeObj: null,
    start: function() {
      const self = this;
      // 清除延时器
      this.timeObj && clearTimeout(this.timeObj);
      this.serverTimeObj && clearTimeout(this.serverTimeObj);
      this.timeObj = setTimeout(function() {
        _ws.send("{'body':{'status':200},'header':{'msgType':'heartbeat'}}"); // 发送消息，服务端返回信息，即表示连接良好，可以在socket的onmessage事件重置心跳机制函数
        // 定义一个延时器等待服务器响应，若超时，则关闭连接，重新请求server建立socket连接
        self.serverTimeObj = setTimeout(function() {
          _ws.close();
          _reconnect();
        }, self.timeOut);
      }, this.timeOut);
    }
  };
  /*
   * 发送消息
   */
  this.send = function(data) {
    if (_ws) {
      // 添加状态判断，当为OPEN时，发送消息
      if (_ws.readyState === 1) {
        _printLog("send-msg", data);
        return _ws.send(data);
      } else if (_ws.readyState === 0) {
        _ws.addEventListener("open", function() {
          _printLog("send-msg", data);
          _ws.send(data);
        });
      }
    } else {
      // eslint-disable-next-line no-throw-literal
      throw "INVALID_STATE_ERR : Pausing to reconnect websocket";
    }
  };

  /*
   * 关闭websocket
   */
  this.close = function() {
    _forcedClose = true;
    if (_ws) {
      _ws.close();
    }
  };

  // /*
  //  * 刷新连接
  //  */
  // function _refresh() {
  //   if (_ws) {
  //     _ws.close();
  //   }
  // }

  /*
   * 重连
   */
  function _reconnect() {
    clearTimeout(_reTimeout);
    _self.connect(true);
  }

  /**
   * 事件订阅
   * @param type 事件类型：onopen、onclose、onconnecting、onmessage、onerror
   * @param subsciber 事件订阅者
   * @param fn 处理函数，返回参数event
   */
  this.on = function(type, subsciber, fn) {
    try {
      const pools = _eventOnPools[type];
      if (pools) {
        if (pools[subsciber] === undefined) {
          pools[subsciber] = fn;
          console.log(
            "websocket.on: 事件[",
            type,
            "]订阅成功，订阅者[",
            subsciber,
            "]"
          );
          return true;
        } else {
          console.warn(
            "websocket.on: 订阅失败，[",
            type,
            "]事件已被[",
            subsciber,
            "]订阅，不能重复订阅!"
          );
        }
      } else {
        console.warn("websocket.on: 订阅失败，[", type, "]事件不存在!");
      }
    } catch (e) {
      console.error(
        "websocket.on: 事件订阅错误：",
        e,
        ", 事件名称[",
        type,
        "], 订阅者[",
        subsciber,
        "]"
      );
    }
    return false;
  };

  /**
   * 取消订阅
   * @param type 事件类型：onopen、onclose、onconnecting、onmessage、onerror
   * @param subsciber 订阅者
   */
  this.off = function(type, subsciber) {
    try {
      const pools = _eventOnPools[type];
      if (pools) {
        if (pools[subsciber]) {
          delete pools[subsciber];
          console.log(
            "websocket.off: 订阅者[",
            subsciber,
            "]已取消[",
            type,
            "]事件订阅!"
          );
          return true;
        } else {
          console.warn(
            "websocket.off: [",
            type,
            "]事件取消订阅失败，订阅者[",
            subsciber,
            "]不存在!"
          );
        }
      } else {
        console.warn("websocket.off: 取消订阅失败，[", type, "]事件不存在!");
      }
    } catch (e) {
      console.error(
        "websocket.off: [",
        type,
        "]事件取消订阅错误: ",
        e,
        ", 订阅者[",
        subsciber,
        "]"
      );
    }
    return false;
  };

  /*
   * 日志打印
   */
  function _printLog(type, event) {
    if (_self.debug) {
      console.log("WebSocket: ", type, "|", _url, "|", event);
    }
  }

  /*
   * 事件处理
   */
  function _handleEvents(type, data) {
    const events = _eventOnPools[type];
    // let hasSubs = false; // 是否有订阅者
    if (events) {
      // hasSubs = false;
      for (const key of Object.keys(events)) {
        try {
          // hasSubs = true;
          events[key](data);
        } catch (e) {
          console.error(
            "websocket.handle: 事件处理错误：",
            e,
            ", 事件名称[",
            type,
            "], 订阅者[",
            key,
            "]"
          );
        }
      }
    }
  }

  /*
   * 连接
   */
  this.connect = function(reconnectAttempt) {
    _ws = new WebSocket(_url, protocols);

    if (reconnectAttempt) {
      _printLog("attempt-connect", "");
    } else {
      _handleEvents("onconnecting", null);
    }

    const timeout = setTimeout(function() {
      _printLog("connection-timeout", "");
      _timedOutStatus = true;
      _ws.close();
      _timedOutStatus = false;
    }, _self.timeoutInterval);

    _ws.onopen = function(event) {
      clearTimeout(timeout);
      _printLog("onopen", event);
      _self.readyState = WebSocket.OPEN;
      _handleEvents("onopen", event);
      reconnectAttempt = false;
      _self.reconnectAttemptCount = 0;
      if (_self.heartState) {
        // 重置心跳机制
        heart.start();
      }
    };

    _ws.onclose = function(event) {
      clearTimeout(timeout);
      _ws = null;
      if (_forcedClose) {
        _self.readyState = WebSocket.CLOSED;
        _handleEvents("onclose", event);
      } else {
        _self.readyState = WebSocket.CONNECTING;
        _handleEvents("onconnecting", event);
        if (!reconnectAttempt && !_timedOutStatus) {
          _printLog("onclose", event);
        }
        if (_self.maxLinks === 0) {
          _reTimeout = setTimeout(function() {
            _self.reconnectAttemptCount++;
            _self.connect(true);
          }, _self.reconnectInterval +
            _self.reconnectDecay * _self.reconnectAttemptCount);
        } else {
          if (_self.reconnectAttemptCount <= _self.maxLinks) {
            _reTimeout = setTimeout(function() {
              _self.reconnectAttemptCount++;
              _self.connect(true);
            }, _self.reconnectInterval +
              _self.reconnectDecay * _self.reconnectAttemptCount);
          }
        }
      }
    };

    /*
     * 接受消息事件
     */
    _ws.onmessage = function(event) {
      _printLog("onmessage", event);
      _handleEvents("onmessage", event);
      // 收到消息表示连接正常，所以重置心跳机制
      if (_self.heartState) {
        // 重置心跳机制
        heart.start();
      }
    };

    /*
     * 异常错误事件
     */
    _ws.onerror = function(event) {
      _printLog("onerror", event);
      _handleEvents("onerror", event);
    };
  };
}

export default MyWebSocket;
